// src/redux/slice/userDescriptionsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "./api";
export const SYSTEM_DESCRIPTION_NAMES = ["admin"];


/**
 * ΦΕΡΝΟΥΜΕ ΟΛΕΣ ΤΙΣ ΙΔΙΟΤΗΤΕΣ
 * GET /api/user-descriptions/
 */
export const fetchUserDescriptions = createAsyncThunk(
  "userDescriptions/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/auth/user-descriptions/");
      return res.data;
    } catch (error) {
      return rejectWithValue("Αποτυχία φόρτωσης ιδιοτήτων.");
    }
  }
);

/**
 * ΔΗΜΙΟΥΡΓΙΑ ΝΕΑΣ ΙΔΙΟΤΗΤΑΣ
 * POST /api/user-descriptions/
 */
export const createUserDescription = createAsyncThunk(
  "userDescriptions/create",
  async ({ name }, { rejectWithValue }) => {
    try {
      const res = await api.post("/auth/user-descriptions/create/", { name });
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Αποτυχία δημιουργίας ιδιότητας."
      );
    }
  }
);

/**
 * ΜΕΤΟΝΟΜΑΣΙΑ ΙΔΙΟΤΗΤΑΣ
 * PUT /api/user-descriptions/{id}/
 */
export const updateUserDescription = createAsyncThunk(
  "userDescriptions/update",
  async ({ id, name }, { rejectWithValue }) => {
    try {
      const res = await api.put(`/auth/user-descriptions/${id}/`, { name });
      return res.data;
    } catch (error) {
      return rejectWithValue("Αποτυχία ενημέρωσης ιδιότητας.");
    }
  }
);

/**
 * ΔΙΑΓΡΑΦΗ ΙΔΙΟΤΗΤΑΣ
 * DELETE /api/user-descriptions/{id}/
 */
export const deleteUserDescription = createAsyncThunk(
  "userDescriptions/delete",
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/auth/user-descriptions/${id}/delete/`);
      return { id };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "Αποτυχία διαγραφής. Η ιδιότητα ίσως χρησιμοποιείται από χρήστες."
      );
    }
  }
);

/**
 * ΣΥΓΧΩΝΕΥΣΗ ΙΔΙΟΤΗΤΩΝ
 * POST /api/user-descriptions/merge/
 */
export const mergeUserDescriptions = createAsyncThunk(
  "userDescriptions/merge",
  async ({ from_id, to_id }, { rejectWithValue }) => {
    try {
      const res = await api.post("/auth/user-descriptions/merge/", {
        from_id,
        to_id,
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Αποτυχία συγχώνευσης."
      );
    }
  }
);

const userDescriptionsSlice = createSlice({
  name: "userDescriptions",
  initialState: {
    items: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchUserDescriptions.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserDescriptions.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchUserDescriptions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // CREATE
      .addCase(createUserDescription.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })

      // UPDATE
      .addCase(updateUserDescription.fulfilled, (state, action) => {
        const updated = action.payload;
        const idx = state.items.findIndex((d) => d.id === updated.id);
        if (idx !== -1) {
          state.items[idx] = updated;
        }
      })

      // DELETE
      .addCase(deleteUserDescription.fulfilled, (state, action) => {
        state.items = state.items.filter((d) => d.id !== action.payload.id);
      })

      // MERGE
      .addCase(mergeUserDescriptions.fulfilled, (state) => {

      });
  },
});

export default userDescriptionsSlice.reducer;
